// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"224":"8a6f23da","424":"d8da9b88","463":"057d67b5","926":"973d4e63"}[chunkId] + ".js";
};